// eslint-disable-next-line max-len
var USER_INTERFACE_INFORMATION_FILLED = 'M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm.36,8a1.8,1.8,0,1,1-1.8,1.8A1.81,1.81,0,0,1,16.36,8Zm3.87,16.7h-8v-2H14.9v-7.2H12.23v-2h5.59v9.2h2.41Z';

export { USER_INTERFACE_INFORMATION_FILLED };
//# sourceMappingURL=USER_INTERFACE_INFORMATION_FILLED.js.map
